import { Button, Flex, Text } from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";
import { CreateCustomerBlock } from "../../components/CustomerBlock/CreateCustomerBlock/CreateCustomerBlock";
import { Layout } from "../../components/Layout/Layout";
import { useFormik } from "formik";
import { useAppDispatch } from "../../store";
import { fetchCreateCustomer } from "../../store/slices/customers";
import { CustomerForm } from "../../model/customers";

export const CreateCustomerPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const formik = useFormik<CustomerForm>({
    initialValues: {
      name: "",
      inn: "",
      description: "",
      business_area_id: null,
      responsible_user_id: null,
      comments: ""
    },
    onSubmit: () => { },
  });


  return (
    <Layout>
      <Flex flexDirection="column" gap="24px" paddingRight="32px" maxH="90vh" overflowY="auto">
        <Text color="gray.500" cursor="pointer" onClick={() => navigate("/customers")} display="flex" alignItems="center" gap="8px">
          <ArrowBackIcon />
          К списку заказчиков
        </Text>
        <Flex flexDirection="column" gap="4px">
          <Text fontSize={30}
            lineHeight="36px"
            fontWeight={700}
            color="#3b515e"
            >Создание заказчика</Text>
          <Text 
            fontSize={16}
            lineHeight="24px"
            fontWeight={400}
            color="#65758b"
          >Заполните информацию о новом заказчике</Text>
        </Flex>
        <CreateCustomerBlock formik={formik} />
        <Flex gap="16px" justifyContent="flex-end">
          <Button onClick={() => navigate("/customers")}>Отмена</Button>
          <Button
            bg="#2563eb"
            color="white"
            _hover={{ bg: "#2563eb" }}
            _active={{ bg: "#2563eb" }}
            onClick={() => {
              dispatch(fetchCreateCustomer({ params: formik.values }))
                .then((res: any) => {
                  if (res.payload.id) {
                    navigate(`/customers/${res.payload.id}`)
                  }
                })
            }}
            isDisabled={formik.values.name === "" || 
              formik.values.business_area_id === null || 
              formik.values.responsible_user_id === null || 
              formik.values.inn === "" ||
              formik.values.inn.length < 10 ||
              formik.values.inn.length > 12}
          >Создать заказчика</Button>
        </Flex>
      </Flex>
    </Layout>
  );
};
